import BaseModel from "../default/base-model";

export class ImportPo extends BaseModel{
    id: number;
    client: number;
    status: StatusImportPo;
    user: string;
    report?: File;
    error_message?: string;


    constructor() {
        super();
        this.id = 0;
        this.client = 0;
        this.status = 0;
        this.user = '';
        this.report = undefined;
        this.error_message = '';
    }
}

export enum StatusImportPo {
    PROCESSING = 1,
    COMPLETED = 2,
    FAIL = 3,
}

export const StatusImportPoLabel = {
    [StatusImportPo.PROCESSING]: {label: 'processing', color: 'info'},
    [StatusImportPo.COMPLETED]: {label: 'processed', color: 'success'},
    [StatusImportPo.FAIL]: {label: 'fail_to_process', color: 'error'},
};
